import type { FC } from "react";
import React, { useMemo } from "react";

import cn from "classnames";

import { extractProps, getChildrenRecord } from "../../../utils/react";

import type { TagsViewProps } from "./types";

import classes from "./TagsView.styl";

export const TAGS_VIEW_DISPLAY_NAME = "TagsView";
const TAGS_VIEW_TEST_ID = "tags-view-test-id";

/**
 * Компонент-обертка для Tag. Необходим для отображения двух и более Tag'ов в ряд.
 *
 * <a href="https://www.figma.com/design/vTg3KAvmAXA9LigeyiqCWL/%F0%9F%92%A0-Base-Components?m=auto&node-id=2-85902&t=xOS5YJTI37Iwp4AM-1" target="_blank">Спека</a>
 * @constructor
 */
export const TagsView: FC<TagsViewProps> = (props) => {
    const { customVarsStyles, currentProps } = extractProps(props, [
        "customVarsStyles",
    ]);

    const { wrapContent = false, "data-tsid": tsid, children } = currentProps;

    const childrenOfTags = useMemo(() => {
        return getChildrenRecord(
            children,
            TAGS_VIEW_DISPLAY_NAME,
            {
                Tag: {
                    required: true,
                },
            },
            {
                isArrayResult: true,
            },
        );
    }, [children]);

    const tagsViewClassname = cn(
        classes["tags-view"],
        {
            [classes["__nowrap"]]: !wrapContent,
        },
        customVarsStyles,
    );

    return (
        <div
            className={tagsViewClassname}
            data-tsid={tsid || TAGS_VIEW_TEST_ID}
            data-uikit={TAGS_VIEW_DISPLAY_NAME}
        >
            {childrenOfTags}
        </div>
    );
};

TagsView.displayName = TAGS_VIEW_DISPLAY_NAME;

export default TagsView;
